<template>
    <span
        class="relative"
        :class="`${
            isHexaColor ? '' : `bg-${color}-100 text-${color}-800`
        } bg-dark-lighter text-text-base mr-2 inline-flex items-center rounded-full p-1.5 text-sm font-semibold`"
        :style="style"
        @click="emits('update:modelValue', !modelValue)"
    >
        <RequiredText v-if="required" class="absolute -top-2 -right-1"> *</RequiredText>
        <svg class="h-3.5 w-3.5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path
                v-if="modelValue"
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
            />
        </svg>
    </span>
</template>

<script setup>
import RequiredText from '@/components/form/RequiredText.vue'

const props = defineProps({
    modelValue: { type: Boolean, default: false },
    color: { type: String, default: 'white' },
    backgroundColor: { type: String, default: null },
    required: { type: Boolean, default: false },
})
const emits = defineEmits(['update:modelValue'])

const isHexaColor = props.color.indexOf('#') !== -1
let style = {}

if (isHexaColor)
    style = {
        'background-color': props.backgroundColor,
        'color': props.color,
    }
</script>
